export const USER_WITH_DUPLICATED_EMAIL = 'Commons.UserWithDuplicatedEmail';
export const USER_MAIL_NOT_FOUND = 'Commons.UserMailNotFound';
export const UNABLE_TO_CHANGE_USER_TYPE = 'Commons.UnableToChangeUserType';
export const COMPANY_WITH_DUPLICATED_DENO_FACTURA = 'Commons.CompanyWithDuplicatedDenoFactura';
export const COMPANY_WITH_DUPLICATED_CIF = 'Commons.CompanyWithDuplicatedCif';
export const DUPLICATED_REAL_ESTATE_CLIENT_FISICA = 'Commons.DuplicatedRealEstateClientFisica';
export const DUPLICATED_REAL_ESTATE_CLIENT_JURIDICA = 'Commons.DuplicatedRealEstateClientJuridica';

export const INVOICE_WITH_DUPLICATED_CODE = 'Operaciones.InvoiceWithDuplicatedCode';
export const INVOICE_MISSING_DECOMMISSION_OPERATIONS = 'Operaciones.InvoiceMissingDecommissionOperations';

export const OPERATION_WITHOUT_SIGNED_CONTRACT = 'Operaciones.OperationWithoutSignedContract';
export const OPERATION_CANNOT_UNDO_STATE = 'Operaciones.OperationCannotUndoState';
export const OPERATION_CONTACT_LEAD_MISSING_DATA = 'Operaciones.OperationContactLeadMissingData';
export const OPERATION_CANNOT_INVALIDATE = 'Operaciones.OperationCannotInvalidate';
export const OPERATION_CANNOT_EDIT = 'Operaciones.OperationCannotEdit';

export const OFFER_WITH_BAD_END_DATE = 'Operaciones.OfferWithBadEndDate';
export const SERVICE_WITH_BAD_END_DATE = 'Operaciones.ServiceWithBadEndDate';

export const AGENT_COMPARISONS_NO_AVAILABLE = "Operaciones.AgentComparisonsNoAvailable";
export const ESAVE_NO_ENERGY_INFO = "Operaciones.EsaveNoEnergyInfo";
export const ESAVE_FAILED_TO_PARSE_INVOICE = "Operaciones.EsaveFailedToParseInvoice";
export const ESAVE_NOT_PROCESABLE_INVOICE = "Operaciones.EsaveNotProcesableInvoice";

export const MARCO_COMISIONES_WITH_DUPLICATED_DENOMINACION = "Commons.MarcoComisionesWithDuplicatedDenominacion";

export const DRAFT_OPERATION_MUST_HAVE_ENERGY = "Operaciones.DraftOperationMustHaveEnergy";
export const DRAFT_OPERATION_CANNOT_TRAMIT_WATER = "Operaciones.DraftOperationCannotTramitWater";
export const DRAFT_OPERATION_ALREADY_IN_COURSE = "Operaciones.DraftOperationAlreadyInCourse";

export const GENERAL_NOT_FOUND = "General.NotFound";
